export const INITIAL_TIMESTAMP_OFFSET = 10000; // 10 seconds in the past

export const INITIAL_ASSISTANT_MESSAGE_TEXT =
  "Describe the test you want to create.";

export const INITIAL_USER_INPUT_CONFIG = {
  type: "text" as const,
  variablePath: "variables.initialTestDescription",
};
